module.exports = __webpack_public_path__ + "img/circle.3adbfce8.png";